import { useEffect, useRef, useState } from 'react';
import * as motion from 'framer-motion/client';
import { useInView } from 'framer-motion';
import styles from './success.module.scss';
import Image from 'next/image';
import T from '../../../common/components/T';
import classNames from 'classnames';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import uikit from '../../../project/uikit/uikit.module.scss';

const SuccessPage = () => {
    const sectionRef = useRef();
    //
    // const { scrollYProgress } = useScroll({
    //     target: sectionRef,
    //     offset: ['start center', 'end end']
    // });

    const desctop = useWindowDimensions() >= 1024;
    const desctopLg = useWindowDimensions() >= 1400;

    const isInView = useInView(sectionRef, { amount: 0.2 });

    const data = [
        {
            index: 0,
            image: '/src/landing/success/success-1.svg',
            imageActive: '/src/landing/success/success-1-active.svg',
            title: <T textName={'landing-successpage-new9'} defaultStr={'Обучение'} page='/' />,
            description: (
                <T
                    textName={'landing-successpage-new10'}
                    defaultStr={'Вы можете проходить системное обучение по нужным модулям и повышать свою квалификацию'}
                    page='/'
                />
            )
        },
        {
            index: 1,
            image: '/src/landing/success/success-2.svg',
            imageActive: '/src/landing/success/success-2-active.svg',
            title: <T textName={'landing-successpage-new11'} defaultStr={'Софт'} page='/' />,
            description: (
                <T
                    textName={'landing-successpage-new12'}
                    defaultStr={'Автоматизация и управления всех бизнес-процессов вашего бизнеса с любой точки мира'}
                    page='/'
                />
            )
        },
        {
            index: 2,
            image: '/src/landing/success/success-3.svg',
            imageActive: '/src/landing/success/success-3-active.svg',
            title: <T textName={'landing-successpage-new13'} defaultStr={'Бизнес-инструменты'} page='/' />,
            description: (
                <T
                    textName={'landing-successpage-new14'}
                    defaultStr={
                        'Готовые видео и печатные материалы, социальные сети, семинары, тренинги, тим билдинги, авторские школы, конференции'
                    }
                    page='/'
                />
            )
        },
        {
            index: 3,
            image: '/src/landing/success/success-4.svg',
            imageActive: '/src/landing/success/success-4-active.svg',
            title: <T textName={'landing-successpage-new15'} defaultStr={'Партнерская программа'} page='/' />,
            description: (
                <T
                    textName={'landing-successpage-new16'}
                    defaultStr={'С высокодоходным, щедрым и устойчивым планом вознаграждений доступным для каждого'}
                    page='/'
                />
            )
        },
        {
            index: 4,
            image: '/src/landing/success/success-5.svg',
            imageActive: '/src/landing/success/success-5-active.svg',
            title: <T textName={'landing-successpage-new17'} defaultStr={'Поддержка'} page='/' />,
            description: (
                <T
                    textName={'landing-successpage-new18'}
                    defaultStr={
                        'Ваши наставники и лидеры всегда готовы дать необходимую профессиональную поддержку на пути становления вашего успеха'
                    }
                    page='/'
                />
            )
        }
    ];

    const [activeItems, setActiveItems] = useState(Array(data.length).fill(false));

    const handleScroll = () => {
        setActiveItems((prevActiveItems) => {
            // Не коммитим новый стейт (и, соответственно, ре-рендер), если ни один
            // элемент фактически не поменял активность — раньше setState с новым
            // массивом вызывался на каждое событие scroll, даже когда значения были
            // теми же самыми.
            let changed = false;
            const nextActiveItems = prevActiveItems.map((prevValue, index) => {
                const element = document.getElementById(`item-${index}`);
                const isActive = element ? element.getBoundingClientRect().bottom <= (window.innerHeight / 3) * 2 : false;
                if (isActive !== prevValue) {
                    changed = true;
                }
                return isActive;
            });
            return changed ? nextActiveItems : prevActiveItems;
        });
    };

    useEffect(() => {
        handleScroll(); // Run initially to set classes on load

        let rafId = null;
        const onScroll = () => {
            // Батчим до одного расчёта за кадр рендера вместо того, чтобы
            // пересчитывать позиции всех элементов на каждое отдельное событие scroll.
            if (rafId === null) {
                rafId = requestAnimationFrame(() => {
                    rafId = null;
                    handleScroll();
                });
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
            }
        };
    }, []);

    return (
        <section ref={sectionRef} className={styles.successWrapper}>
            {desctop ? null : (
                <motion.div
                    className={classNames(styles.mainWrapperDecor)}
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.25, ease: 'linear' }}
                    viewport={{ amount: 0.25 }}
                >
                    <Image src='/src/landing/carousel/slider-bg-decor_mob.svg' alt={'slider decor'} fill />
                </motion.div>
            )}
            <div className={uikit.container}>
                <div className={classNames(uikit.row, uikit.justifyContentBetween)}>
                    <div
                        className={classNames(uikit.col_xxl_6, uikit.col_lg_6, uikit.positionRelative, styles.customColumn_1024)}
                    >
                        <div className={styles.mainContentWrapperBlock}>
                            {desctop ? (
                                <motion.div
                                    className={classNames(styles.mainWrapperDecor, styles.mainWrapperDecor_Lg)}
                                    initial={{ opacity: 0, scale: 0.5 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ delay: 0.25, duration: 0.5, ease: 'linear' }}
                                    viewport={{ amount: 0.25 }}
                                >
                                    <Image src='/src/landing/carousel/slider-bg-decor.svg' alt={'slider decor'} fill />
                                </motion.div>
                            ) : null}
                            <div className={styles.successBlockStatic}>
                                <motion.h2
                                    initial={{ y: '120%' }}
                                    animate={!isInView ? {} : { y: 0 }}
                                    transition={{ duration: 0.25, ease: 'linear' }}
                                    className={styles.successTitleStatic}
                                >
                                    <T textName={'landing-main_globaltrend_text'} defaultStr={'Global Trend'} page='/' />
                                </motion.h2>
                            </div>
                            <div className={styles.mainContentWrapper}>
                                <div>
                                    <div className={styles.textWrapper}>
                                        <div className={styles.textBlock}>
                                            <motion.h2
                                                initial={{ y: desctopLg ? '140%' : 0, opacity: desctopLg ? 1 : 0 }}
                                                animate={!isInView ? {} : { y: 0, opacity: desctopLg ? 1 : 1 }}
                                                transition={{ duration: 0.25, ease: 'linear' }}
                                                className={styles.successTitle}
                                            >
                                                <T
                                                    textName={'landing-successpage-new1'}
                                                    defaultStr={'Ваш путь к успеху'}
                                                    page='/'
                                                />
                                            </motion.h2>
                                        </div>
                                        <div className={styles.textBlock}>
                                            <motion.h2
                                                initial={{ y: desctopLg ? '140%' : 0, opacity: desctopLg ? 1 : 0 }}
                                                animate={!isInView ? {} : { y: 0, opacity: desctopLg ? 1 : 1 }}
                                                transition={{ duration: 0.25, ease: 'linear' }}
                                                className={classNames(styles.successTitle, styles.text10)}
                                            >
                                                <T
                                                    textName={'landing-successpage-new2'}
                                                    defaultStr={'начинается здесь'}
                                                    page='/'
                                                />
                                            </motion.h2>
                                        </div>
                                    </div>
                                    {desctopLg ? (
                                        <div className={styles.descriptionWrapper}>
                                            <div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new3'}
                                                            defaultStr={'Став партнером Global Trend, вы приобретаете не только'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new4'}
                                                            defaultStr={'высококачественные продукты, но и инструменты для'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new5'}
                                                            defaultStr={'построения собственного бизнеса.'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                            </div>
                                            <div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new6'}
                                                            defaultStr={'Мы предлагаем системное обучение, инновационную'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new7'}
                                                            defaultStr={'платформу, бизнес - инструменты по продвижению'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                                <div className={styles.descriptionBlock}>
                                                    <motion.p
                                                        initial={{ y: '120%' }}
                                                        animate={!isInView ? {} : { y: 0 }}
                                                        transition={{ duration: 0.25, ease: 'linear' }}
                                                        className={styles.descriptionText}
                                                    >
                                                        <T
                                                            textName={'landing-successpage-new8'}
                                                            defaultStr={'и партнерскую программу.'}
                                                            page='/'
                                                        />
                                                    </motion.p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.descriptionWrapper}>
                                            <motion.p
                                                initial={{ opacity: 0, y: 0 }}
                                                animate={!isInView ? {} : { opacity: 1, y: 0 }}
                                                transition={{ duration: 0.25, ease: 'linear' }}
                                                className={styles.descriptionText}
                                            >
                                                <T
                                                    textName={'landing-successpage-new3_common'}
                                                    defaultStr={
                                                        'Став партнером Global Trend, вы приобретаете не только высококачественные продукты, но и инструменты для построения собственного бизнеса.'
                                                    }
                                                    page='/'
                                                />
                                            </motion.p>

                                            <motion.p
                                                initial={{ opacity: 0, y: '40%' }}
                                                animate={!isInView ? {} : { y: 0, opacity: 1 }}
                                                transition={{ duration: 0.25, ease: 'linear' }}
                                                className={styles.descriptionText}
                                            >
                                                <T
                                                    textName={'landing-successpage-new6_common'}
                                                    defaultStr={
                                                        'Мы предлагаем системное обучение, инновационную платформу, бизнес - инструменты по продвижению, а также партнерскую программу.'
                                                    }
                                                    page='/'
                                                />
                                            </motion.p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classNames(uikit.col_xxl_5, uikit.col_lg_6, styles.customColumn_1024)}>
                        <div className={styles.imagesWrapper}>
                            {data.map((item, index) => (
                                <motion.div
                                    key={index}
                                    id={`item-${index}`}
                                    className={`${styles.imageWrapper} ${activeItems[index] ? styles.imageWrapperActive : ''}`}
                                    transition={{ delay: index * 0.25, duration: 0.25 }}
                                >
                                    <div className={styles.imageWrapper_content}>
                                        <div className={styles.imageWrapper__title}>{item.title}</div>
                                        <div className={styles.imageWrapper__description}>{item.description}</div>
                                    </div>
                                    <Image
                                        src={activeItems[index] ? item.imageActive : item.image}
                                        alt={`${item.image}_${item.index}`}
                                        sizes='(max-width: 768px) 64px, 76px'
                                        width={76}
                                        height={76}
                                    />
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.successDecorWrapper}>
                <motion.div
                    className={styles.ellips1Wrapper}
                    style={{
                        transition: 'transform 1s linear 2s',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1-new' width={240} height={240} />
                </motion.div>
                <motion.div
                    className={styles.ellips2Wrapper}
                    style={{
                        transition: 'transform 1s linear 2s',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1-new' width={240} height={240} />
                </motion.div>
                <motion.div
                    className={styles.ellips3Wrapper}
                    style={{
                        transition: 'transform 1s linear 2s',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1-new' width={240} height={240} />
                </motion.div>
                <motion.div
                    className={styles.ellips4Wrapper}
                    style={{
                        transition: 'transform 1s linear 2s',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1-new' width={240} height={240} />
                </motion.div>
                <motion.div
                    className={styles.ellips5Wrapper}
                    style={{
                        transition: 'transform 1s linear 2s',
                        y: !isInView ? '-140%' : 0,
                        x: !isInView ? '50%' : 0
                    }}
                >
                    <Image src={'ellipse.svg'} alt='ellipse icon1-new' width={320} height={320} />
                </motion.div>
            </div>
        </section>
    );
};
export default SuccessPage;
